import React, {Component} from 'react';
import ReactModal from 'react-modal';
import HelpModalSlide from './HelpModalSlide';

import Swiper from 'react-id-swiper';

class HelpModal extends React.Component {

  render() {
    const {content, open, handleCloseModal} = this.props;
    const {items, size} = content;
    const params = {
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      centeredSlides: true,
      spaceBetween: 30
    }

    const appElement = document.getElementById("nppe2-feeding-calc-react-app");

    return (
      <div role="dialog" aria-modal="true">
        <ReactModal
          className="nppe2-fc-help-modal"
          closeTimeoutMS={250}
          shouldFocusAfterRender={false}
          appElement={appElement}
          style={{
            overlay: {
              backgroundColor: "rgba(0,0,0,0.75)",
            },
            content: {}
          }}
          isOpen={open}>

          <div className="nppe2-fc-help-modal__wrapper">

            {items.length > 1 ? (
              <div className="container">
                <div className="row">
                  <div className={size}>
                  <Swiper {...params}>
                    {items.map((item, index) => (
                      <div key={index}>
                        <div className="nppe2-fc-help-modal__inner">
                          <div className="nppe2-fc-help-modal__close"
                            onClick={handleCloseModal} ></div>

                          <HelpModalSlide
                            item={item}
                            key={index}/>
                        </div>
                      </div>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </div>
            ) : (
              <div className="container">
                <div className="row">
                  <div className={size}>
                    <div className="nppe2-fc-help-modal__inner">

                      <div className="nppe2-fc-help-modal__close"
                        onClick={handleCloseModal} ></div>

                      {items.length > 0 && <HelpModalSlide item={items[0]}/> }
                    </div>
                  </div>
                </div>
              </div>
            )};

          </div>

        </ReactModal>

      </div>
    )
  };

};

export default HelpModal;
